import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { ajax } from '@blade/common';
let Organization = class Organization extends VuexModule {
    selectedRow = [];
    organization = {};
    async getOrganizationTree() {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/user-management/api/v1/ums/org/tree/',
                params: {},
                data: {},
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getOrganizations({ page = 1, size = 10 }) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: '/api/user-management/api/v1/ums/org/list/',
                // headers: { accessToken: process.env.VUE_APP_TEST },
                params: {},
                data: { page, size },
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async getOrganizationDetail(id) {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: `/api/user-management/api/v1/ums/org/${id}`,
                // headers: { accessToken: process.env.VUE_APP_TEST },
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async updateOrganizationDetail(data) {
        try {
            const res = await ajax.request({
                method: 'PUT',
                url: `/api/user-management/api/v1/ums/org`,
                // headers: { accessToken: process.env.VUE_APP_TEST },
                data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async createOrganization(data) {
        try {
            const res = await ajax.request({
                method: 'POST',
                url: `/api/user-management/api/v1/ums/org`,
                // headers: { accessToken: process.env.VUE_APP_TEST },
                data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async deleteOrganization(id) {
        try {
            const res = await ajax.request({
                method: 'DELETE',
                url: `/api/user-management/api/v1/ums/org/${id}`,
                // headers: { accessToken: process.env.VUE_APP_TEST },
            });
        }
        catch (e) {
            throw e;
        }
    }
    updateAccount(payload) {
        this.organization = payload;
    }
    updateSelectedRow(payload) {
        this.selectedRow = payload;
    }
};
__decorate([
    Action({ rawError: true })
], Organization.prototype, "getOrganizationTree", null);
__decorate([
    Action({ rawError: true })
], Organization.prototype, "getOrganizations", null);
__decorate([
    Action({ rawError: true })
], Organization.prototype, "getOrganizationDetail", null);
__decorate([
    Action({ rawError: true })
], Organization.prototype, "updateOrganizationDetail", null);
__decorate([
    Action({ rawError: true })
], Organization.prototype, "createOrganization", null);
__decorate([
    Action({ rawError: true })
], Organization.prototype, "deleteOrganization", null);
__decorate([
    Mutation
], Organization.prototype, "updateAccount", null);
__decorate([
    Mutation
], Organization.prototype, "updateSelectedRow", null);
Organization = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/organization' })
], Organization);
export const OrganizationModule = getModule(Organization);
